import React from 'react'

import { HtmlNotesPreview } from '../html-preview/HtmlNotesPreview'

interface ConsentFormRichTextProps {
  readonly value: string
}

export function ConsentFormRichText({ value }: ConsentFormRichTextProps) {
  return <HtmlNotesPreview notes={value} />
}
